import { EVERYONE_SENTINEL, PipelineCardSort, UserId } from "@sp-crm/core";
import { produce } from "immer";
import { Action } from "redux";
import { Actions } from "../actions";

export type ReferralPipelineAssigneeFilter = UserId | typeof EVERYONE_SENTINEL | "";

export interface ReferralPipelineSearchInstance {
    searchText: string;
    assignee: ReferralPipelineAssigneeFilter;
    cardSortPreference: PipelineCardSort;
}

export interface ReferralPipelineSearchState {
    referralPipelineSearchInstance: ReferralPipelineSearchInstance;
}

export function referralPipelineSearchReducer(
    originalState: ReferralPipelineSearchState,
    action: Action,
): ReferralPipelineSearchState {
    if (
        !originalState ||
        action.type === Actions[Actions.LOGOUT] ||
        action.type === Actions[Actions.SELECT_REGION]
    ) {
        originalState = {
            referralPipelineSearchInstance: {
                searchText: "",
                assignee: EVERYONE_SENTINEL,
                cardSortPreference: "updatedAtDesc",
            },
        };
    }

    return produce(originalState, state => {
        if (action.type === Actions[Actions.REFERRAL_PIPELINES_SEARCH_TEXT]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            state.referralPipelineSearchInstance.searchText = (action as any).searchText;
        }
        if (action.type === Actions[Actions.REFERRAL_PIPELINES_SELECT_ASSIGNEE]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            state.referralPipelineSearchInstance.assignee = (action as any).assignee;
        }
        if (action.type === Actions[Actions.REFERRAL_PIPELINES_SORT]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            const sortAction = action as any;
            state.referralPipelineSearchInstance.cardSortPreference = sortAction.cardSort;
        }
    });
}
